import React from 'react';
import HubPage from '../../ui-components/HubPage';

const ITEM_META = {
  '/dagstart': { icon: 'wb_sunny', desc: 'Vandaag per persoon: taken, afspraken en capaciteit' },
  '/draaidagen': { icon: 'videocam', desc: 'Alle shoots met voorbereidings- en planningstatus' },
  '/planning/inplannen': { icon: 'pending_actions', desc: 'Gedraaid maar nog geen montage gepland, taken zonder eigenaar, deadline-check' },
  '/planning/overzicht-per-project': { icon: 'table_chart', desc: 'Alle taken per project en deliverable, als spreadsheet' },
  '/planning/weekoverzicht-pl': { icon: 'calendar_view_week', desc: 'Taken en deadlines van jouw projecten, per week' },
  '/slimme-toewijzing': { icon: 'auto_awesome', desc: 'Voorstel wie welke taak oppakt, op functie en beschikbaarheid' },
  '/draaidag-planner': { icon: 'event_available', desc: 'Vind weken of klantopties waarin de crew kan draaien' },
  '/task-board': { icon: 'view_week', desc: 'Weekoverzicht met taken per dag' },
  '/capacity': { icon: 'grid_view', desc: 'Bezetting en beschikbaarheid per medewerker' },
  '/planner-todo': { icon: 'assignment_ind', desc: 'Sleep nog in te plannen taken op personen, met de capaciteit eronder' },
  '/MaterialReservation': { icon: 'photo_camera', desc: "Reserveer camera's, lenzen en gear" },
  '/planning/corvee': { icon: 'cleaning_services', desc: 'Eerlijk corveerooster op beschikbaarheid + saldo' },
  '/materiaal-beheer': { icon: 'inventory_2', desc: 'Beheer alle materialen, exemplaren en sets' },
  '/materiaal-beheer/materialen': { icon: 'inventory_2', desc: 'Beheer alle materialen, exemplaren en sets' },
  '/planning/voertuigen': { icon: 'directions_car', desc: 'Kilometers & brandstofverbruik per voertuig' },
};

export default function PlanningHub() {
  return (
    <HubPage
      sectionKey="planning"
      subtitle="Teamplanning en resources"
      headerIcon="view_week"
      itemMeta={ITEM_META}
    />
  );
}
